import { t } from "i18next";
import { AppRadioButton } from "../../components/UI/AppRadioButtons/AppRadioButtons";
import {
  CompanyInvoiceFormFields,
  ReadOnlyIfInitialValuesNotProvided,
} from "../../components/Layouts/WebCheckInForms/FormOptions";
import { RegisterOptions } from "react-hook-form";
import { AppInputSwitcher } from "../../components/Layouts/AppInputSwitcher/AppInputSwitcher";
import { FormFieldErrorMessage } from "../../components/UI/FormFieldErrorMessage/FormFieldErrorMessage";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useWebCheckInForm } from "../../hooks/WebCheckInForm_2";
import {
  DefaultValuesDetailsForm,
  IndividualFormProps,
} from "../../components/Layouts/WebCheckInForms/WebCheckInForms.props";
import PrivatePersonalDetails from "./PrivatePersonalDetails";
import BookingGetters from "../../store/onlineBooking/getters";
import i18n from "../../config/i18n";
import { AppStandardMultiSelectCheckBox } from "../../components/UI/AppMultipleSelection";
import AppCountrySelect from "../../components/Layouts/AppCountrySelect";
import Container from "@mui/material/Container";
import { createFilterOptions } from "@mui/material";

function NewCompanyDetails(
  {
    userType,
    handleUserType,
    setCompanyinvoiceDetails,
    companyinvoiceDetails,
    phoneError,
    setHandleBillingHeight,
    phoneRef,
    dateError,
    isAirport,
    hideNumberOfFieldsAtPayAtDesk,
    paymentType,
    reservationSourcePayLater,
    reservationSourcePayNow,
    scriptChannel,
  }: any,
  {
    onSubmit = () => {},
    values = {},
    initialValues = { ...DefaultValuesDetailsForm },
    onChange = () => {},
  }: IndividualFormProps
) {
  const [
    {
      setValue,
      getValues,
      register,
      reset,
      formState: { errors },
    },
    individualFormFields,
  ] = useWebCheckInForm(
    CompanyInvoiceFormFields,
    {
      ...Object.keys(values).reduce((prevValue, currentKey) => {
        prevValue[currentKey] =
          prevValue[currentKey] || initialValues[currentKey];
        return prevValue;
      }, values),
    },
    onChange
  );

  const { t: translate } = useTranslation();
  const [taxVal, setTaxVal] = useState("9999999999999999");
  const [isReadonly, setIsReadonly] = useState<boolean>(true);
  const istabletScreen = window.innerWidth > 768 && window.innerWidth < 1300;
  const [userId] = useState(localStorage.getItem("userID"));
  const [privatePersonalDetails, setPrivatePersonalDetails] = useState({
    ...DefaultValuesDetailsForm,
  });
  const AppSettings = BookingGetters.getAppSettings();

  const lang = i18n.language;
  const textResource = BookingGetters.getTextResourceDetailsBasedOnLang();
  const isSmallScreen = window.innerWidth <= 768;
  const data = textResource?.[lang]?.flatMap((item) => item.data || []) || [];

  const [requiredFieldLabel, setRequiredFieldLabel] = useState<string>("");
  const [companyDetailsLabel, setCompanyDetailsLabel] = useState<string>("");
  const [companyDetailsLabelRes, setCompanyDetailsLabelRes] =
    useState<string>("");
  const [userTypeManuallySelected, setUserTypeManuallySelected] =
    useState<boolean>(false);

  const hideNumberOfFieldsAtPayNow =
    AppSettings?.hideNumberOfFieldsAtPayNow ?? false;

  const [showBillingDetails, setShowBillingDetails] = useState<boolean>(false);

  const showOnePrice = AppSettings?.showOnePayMethodTwoPrice;
  const hideFieldsPayNowScriptChannel =
    paymentType === "payNow" &&
    reservationSourcePayNow == "false" &&
    reservationSourcePayLater == "false" &&
    scriptChannel &&
    hideNumberOfFieldsAtPayNow;
  const shouldShowBillingCheckbox = useMemo(() => {
    // if (showOnePrice) return false;
    return (
      (paymentType === "payNow" && hideNumberOfFieldsAtPayNow) ||
      (paymentType === "payLater" && hideNumberOfFieldsAtPayAtDesk) ||
      hideFieldsPayNowScriptChannel
    );
  }, [
    paymentType,
    hideNumberOfFieldsAtPayNow,
    hideNumberOfFieldsAtPayAtDesk,
    showOnePrice,
  ]);
  useEffect(() => {
    setUserTypeManuallySelected(false);
  }, [paymentType, shouldShowBillingCheckbox]);
  const shouldShowFullForm = !shouldShowBillingCheckbox || showBillingDetails;

  useEffect(() => {
    setUserTypeManuallySelected(false);
  }, [paymentType, shouldShowBillingCheckbox]);

  useEffect(() => {
    setShowBillingDetails(false);
    handleUserType("");
    reset(DefaultValuesDetailsForm);
    setPrivatePersonalDetails(DefaultValuesDetailsForm);
    setCompanyinvoiceDetails({});
    setTaxVal("9999999999999999");
    setIsReadonly(true);
  }, [paymentType, hideNumberOfFieldsAtPayNow, hideNumberOfFieldsAtPayAtDesk]);

  useEffect(() => {
    if (userTypeManuallySelected) return;

    if (!showOnePrice || showOnePrice) {
      if (shouldShowBillingCheckbox) {
        handleUserType("");
      }
      if (!shouldShowBillingCheckbox) {
        if (userType !== "Private") handleUserType("Private");
      }
    }

    if (shouldShowBillingCheckbox) {
      if (!showBillingDetails) {
        handleUserType("");
      }
      return;
    }

    if (!userType) handleUserType("Private");
  }, [
    paymentType,
    shouldShowBillingCheckbox,
    userType,
    showBillingDetails,
    showOnePrice,
  ]);

  useEffect(() => {
    const req = data.find((i) => i.key === "RequiredFieldLabel");
    const comp = data.find((i) => i.key === "companyDetailsLabel");
    const compRes = data.find((i) => i.key === "companyDetailsLabelRes");

    setRequiredFieldLabel(req?.body || translate("This is a required field"));
    setCompanyDetailsLabel(comp?.body || translate("company_details"));
    setCompanyDetailsLabelRes(compRes?.body || "Intestatario contratto");
  }, [data, translate]);

  const prefixFilterOptions = createFilterOptions({
    limit: 50,
    matchFrom: "start",
  });

  const handleCountryChange = (val: string): void => {
    setValue("country", val || "");
    setValue("city", "");
    setValue("state", "");
  };

  const handleManualUserTypeChange = (val: string): void => {
    setUserTypeManuallySelected(true);
    handleUserType(val);
  };

  useEffect(() => {
    setHandleBillingHeight((prev: boolean) => !prev);
  }, [showBillingDetails]);
  useEffect(() => {
    if (!userTypeManuallySelected) return;

    reset(DefaultValuesDetailsForm);
  }, [userType]);

  return (
    <div className={`bg-white box-border ${isSmallScreen ? "p-2" : "p-8"}`}>
      {shouldShowBillingCheckbox && (
        <AppStandardMultiSelectCheckBox
          key={paymentType + (showBillingDetails ? "1" : "0")}
          required={false}
          color="primary"
          value={showBillingDetails ? ["showBilling"] : []}
          options={[
            { label: t("Enter Billing Details"), value: "showBilling" },
          ]}
          onChange={(vals) => {
            const checked = vals.includes("showBilling");
            setShowBillingDetails(checked);
            if (!checked) handleUserType("");
          }}
          className="py-2 mb-5"
        />
      )}

      {shouldShowFullForm && (
        <>
          <h2
            className="text-xl font-bold text-black pb-8"
            style={{
              paddingLeft: isSmallScreen ? ".7rem" : "",
              paddingTop: isSmallScreen ? "2rem" : "",
              marginTop: showBillingDetails ? "25px" : "'",
            }}
          >
            {userId ? companyDetailsLabelRes : companyDetailsLabel}
          </h2>

          <div className={`flex flex-col ${isSmallScreen ? "px-2" : ""}`}>
            <AppRadioButton
              required={true}
              value={userType}
              onChange={handleManualUserTypeChange}
              options={[
                { label: t("Private"), value: "Private" },
                { label: t("Company"), value: "Company" },
                { label: t("Individual"), value: "Individual" },
              ]}
              color="primary"
            />

            {userType && userType === "Private" ? (
              <PrivatePersonalDetails
                userDetails={privatePersonalDetails}
                setUserDetails={setPrivatePersonalDetails}
                dateError={dateError}
                isAirport={isAirport}
                hideNumberOfFieldsAtPayAtDesk={hideNumberOfFieldsAtPayAtDesk}
                hideNumberOfFieldsAtPayNow={hideNumberOfFieldsAtPayNow}
                paymentType={paymentType}
              />
            ) : userType ? (
              <div
                className={`grid sm:grid-cols-2 ${
                  istabletScreen ? "md:grid-cols-2" : "md:grid-cols-3"
                } gap-4`}
                style={{
                  padding: isSmallScreen ? "0px" : "2rem",
                }}
              >
                {Object.values(individualFormFields).map((el: any, index) => {
                  let taxValue = "";
                  let readOnly;
                  const telephoneValue =
                    el.key === "telephone"
                      ? getValues(el.key) ||
                        initialValues[el.key] ||
                        values[el.key] ||
                        ""
                      : "";
                  el.readOnly ||
                    (ReadOnlyIfInitialValuesNotProvided.includes(el.key) &&
                      !!initialValues[el.key]);
                  const shouldValidate = !(
                    hideNumberOfFieldsAtPayAtDesk && paymentType === "payLater"
                  );
                  const options: RegisterOptions = {
                    required: {
                      value:
                        el.key === "vatNumber"
                          ? true
                          : !!el.required && !readOnly && shouldValidate,
                      message: requiredFieldLabel,
                    },
                  };
                  if (el.type === "email") {
                    options.pattern = {
                      value: /^[a-zA-Z\d+_.-]+@[a-zA-Z\d.-]+$/,
                      message: "Please provide a valid email",
                    };
                  }
                  if (el.key === "vatNumber") {
                    options.validate = (value) => {
                      const birthNation = getValues("birthNation");
                      if (birthNation === "ITALIA" || userType === "Company") {
                        if (!/^\d+$/.test(value))
                          return t("VAT number must contain only digits");
                        if (value.length !== 11)
                          return t("VAT number must be 11 digits long");
                      }
                      return true;
                    };
                  }
                  if (el.key === "taxCode") {
                    taxValue = taxVal;
                    readOnly = isReadonly;
                  } else {
                    taxValue = "";
                  }
                  return (
                    <>
                      {userType === "Company" &&
                      (el.key === "birthNation" ||
                        el.key === "birthPlace" ||
                        el.key === "dateOfBirth" ||
                        el.key === "birthProvince" ||
                        el.key === "taxCode" ||
                        el.key === "firstName" ||
                        el.key === "lastName" ||
                        el.key === "sex") ? (
                        ""
                      ) : (
                        <div
                          key={index}
                          style={{
                            paddingBottom:
                              isSmallScreen && el.key === "sex"
                                ? "20px"
                                : "0px",
                          }}
                        >
                          {/*  CUSTOM COUNTRY SELECT */}
                          {el.key === "country" || el.key === "birthNation" ? (
                            <>
                              <div key={el.key} className="country-section">
                                <AppCountrySelect
                                  fieldKey={el.key}
                                  label={el.label}
                                  options={el.options || []}
                                  value={
                                    getValues(el.key) ||
                                    initialValues[el.key] ||
                                    values[el.key] ||
                                    ""
                                  }
                                  readOnly={readOnly}
                                  required={
                                    (el.key === "country" &&
                                      AppSettings?.countryRequired &&
                                      (AppSettings?.showOnePayMethodTwoPrice ||
                                        !(
                                          (paymentType === "payNow" &&
                                            hideNumberOfFieldsAtPayNow) ||
                                          (paymentType === "payLater" &&
                                            hideNumberOfFieldsAtPayAtDesk)
                                        ))) ||
                                    (el.key === "birthNation" &&
                                      AppSettings?.birthNationRequired &&
                                      (AppSettings?.showOnePayMethodTwoPrice ||
                                        !(
                                          (paymentType === "payNow" &&
                                            hideNumberOfFieldsAtPayNow) ||
                                          (paymentType === "payLater" &&
                                            hideNumberOfFieldsAtPayAtDesk)
                                        )))
                                  }
                                  translate={translate}
                                  formStates={{ setValue }}
                                  setUserDetails={(updated: any) => {
                                    setCompanyinvoiceDetails(updated);
                                  }}
                                  onChange={(val: string) =>
                                    setValue.setValue(el.key, val)
                                  }
                                  cityFieldName={
                                    el.key === "country" ? "city" : "birthPlace"
                                  }
                                  stateFieldName={
                                    el.key === "country"
                                      ? "state"
                                      : "birthProvince"
                                  }
                                />

                                <FormFieldErrorMessage>
                                  {errors[el.key]?.message}
                                </FormFieldErrorMessage>
                              </div>
                            </>
                          ) : (
                            /*  ORIGINAL INPUT SWITCHER */
                            <>
                              <AppInputSwitcher
                                {...el}
                                key={index}
                                autocomplete={false}
                                inputRef={
                                  el.key === "telephone" &&
                                  phoneRef &&
                                  AppSettings?.phoneNoRequired
                                }
                                required={
                                  (el.key === "firstName" &&
                                    AppSettings?.firstNameRequired &&
                                    (AppSettings?.showOnePayMethodTwoPrice ||
                                      !(
                                        (paymentType === "payNow" &&
                                          hideNumberOfFieldsAtPayNow) ||
                                        (paymentType === "payLater" &&
                                          hideNumberOfFieldsAtPayAtDesk)
                                      ))) ||
                                  (el.key === "lastName" &&
                                    AppSettings?.lastNameRequired &&
                                    (AppSettings?.showOnePayMethodTwoPrice ||
                                      !(
                                        (paymentType === "payNow" &&
                                          hideNumberOfFieldsAtPayNow) ||
                                        (paymentType === "payLater" &&
                                          hideNumberOfFieldsAtPayAtDesk)
                                      ))) ||
                                  (el.key === "companyName" &&
                                    AppSettings?.companyNameRequired &&
                                    (AppSettings?.showOnePayMethodTwoPrice ||
                                      !(
                                        (paymentType === "payNow" &&
                                          hideNumberOfFieldsAtPayNow) ||
                                        (paymentType === "payLater" &&
                                          hideNumberOfFieldsAtPayAtDesk)
                                      ))) ||
                                  (el.key === "telephone" &&
                                    telephoneValue.length < 5 &&
                                    AppSettings?.phoneNoRequired &&
                                    (AppSettings?.showOnePayMethodTwoPrice ||
                                      !(
                                        (paymentType === "payNow" &&
                                          hideNumberOfFieldsAtPayNow) ||
                                        (paymentType === "payLater" &&
                                          hideNumberOfFieldsAtPayAtDesk)
                                      ))) ||
                                  (el.key === "email" &&
                                    AppSettings?.emailRequired &&
                                    (AppSettings?.showOnePayMethodTwoPrice ||
                                      !(
                                        (paymentType === "payNow" &&
                                          hideNumberOfFieldsAtPayNow) ||
                                        (paymentType === "payLater" &&
                                          hideNumberOfFieldsAtPayAtDesk)
                                      ))) ||
                                  (el.key === "city" &&
                                    AppSettings?.cityRequired &&
                                    (AppSettings?.showOnePayMethodTwoPrice ||
                                      !(
                                        (paymentType === "payNow" &&
                                          hideNumberOfFieldsAtPayNow) ||
                                        (paymentType === "payLater" &&
                                          hideNumberOfFieldsAtPayAtDesk)
                                      ))) ||
                                  (el.key === "dateOfBirth" &&
                                    AppSettings?.birthDateRequired &&
                                    (AppSettings?.showOnePayMethodTwoPrice ||
                                      !(
                                        (paymentType === "payNow" &&
                                          hideNumberOfFieldsAtPayNow) ||
                                        (paymentType === "payLater" &&
                                          hideNumberOfFieldsAtPayAtDesk)
                                      ))) ||
                                  (el.key === "birthPlace" &&
                                    AppSettings?.birthPlaceRequired &&
                                    (AppSettings?.showOnePayMethodTwoPrice ||
                                      !(
                                        (paymentType === "payNow" &&
                                          hideNumberOfFieldsAtPayNow) ||
                                        (paymentType === "payLater" &&
                                          hideNumberOfFieldsAtPayAtDesk)
                                      ))) ||
                                  (el.key === "streetName" &&
                                    AppSettings?.streetNameRequired &&
                                    (AppSettings?.showOnePayMethodTwoPrice ||
                                      !(
                                        (paymentType === "payNow" &&
                                          hideNumberOfFieldsAtPayNow) ||
                                        (paymentType === "payLater" &&
                                          hideNumberOfFieldsAtPayAtDesk)
                                      ))) ||
                                  (el.key === "street number" &&
                                    AppSettings?.nRequired &&
                                    (AppSettings?.showOnePayMethodTwoPrice ||
                                      !(
                                        (paymentType === "payNow" &&
                                          hideNumberOfFieldsAtPayNow) ||
                                        (paymentType === "payLater" &&
                                          hideNumberOfFieldsAtPayAtDesk)
                                      ))) ||
                                  (el.key === "birthProvince" &&
                                    AppSettings?.birthProvRequired &&
                                    (AppSettings?.showOnePayMethodTwoPrice ||
                                      !(
                                        (paymentType === "payNow" &&
                                          hideNumberOfFieldsAtPayNow) ||
                                        (paymentType === "payLater" &&
                                          hideNumberOfFieldsAtPayAtDesk)
                                      ))) ||
                                  (el.key === "CompanyEInvoicingEmail" &&
                                    AppSettings?.sdiEmailRequired &&
                                    (AppSettings?.showOnePayMethodTwoPrice ||
                                      !(
                                        (paymentType === "payNow" &&
                                          hideNumberOfFieldsAtPayNow) ||
                                        (paymentType === "payLater" &&
                                          hideNumberOfFieldsAtPayAtDesk)
                                      ))) ||
                                  (el.key === "CompanyEInvoicingCode" &&
                                    AppSettings?.sdiCodeRequired &&
                                    (AppSettings?.showOnePayMethodTwoPrice ||
                                      !(
                                        (paymentType === "payNow" &&
                                          hideNumberOfFieldsAtPayNow) ||
                                        (paymentType === "payLater" &&
                                          hideNumberOfFieldsAtPayAtDesk)
                                      ))) ||
                                  (el.key === "zip" &&
                                    AppSettings?.zipCodeRequired &&
                                    (AppSettings?.showOnePayMethodTwoPrice ||
                                      !(
                                        (paymentType === "payNow" &&
                                          hideNumberOfFieldsAtPayNow) ||
                                        (paymentType === "payLater" &&
                                          hideNumberOfFieldsAtPayAtDesk)
                                      ))) ||
                                  (el.key === "vatNumber" &&
                                    AppSettings?.genderRequired &&
                                    (AppSettings?.showOnePayMethodTwoPrice ||
                                      !(
                                        (paymentType === "payNow" &&
                                          hideNumberOfFieldsAtPayNow) ||
                                        (paymentType === "payLater" &&
                                          hideNumberOfFieldsAtPayAtDesk)
                                      ))) ||
                                  (el.key === "sex" &&
                                    AppSettings?.genderRequired &&
                                    (AppSettings?.showOnePayMethodTwoPrice ||
                                      !(
                                        (paymentType === "payNow" &&
                                          hideNumberOfFieldsAtPayNow) ||
                                        (paymentType === "payLater" &&
                                          hideNumberOfFieldsAtPayAtDesk)
                                      ))) ||
                                  (el.key === "CompanySSNNumber" &&
                                    AppSettings?.ssnRequired &&
                                    (AppSettings?.showOnePayMethodTwoPrice ||
                                      !(
                                        paymentType === "payLater" &&
                                        hideNumberOfFieldsAtPayAtDesk
                                      )))
                                }
                                {...register(el.key, { ...options })}
                                readOnly={readOnly}
                                value={
                                  getValues(el.key) ||
                                  initialValues[el.key] ||
                                  values[el.key] ||
                                  taxValue ||
                                  ""
                                }
                                options={
                                  el.key === "sex"
                                    ? [translate("MALE"), translate("FEMALE")]
                                    : el.options
                                }
                                {...((el.key === "city" ||
                                  el.key === "birthPlace") && {
                                  filterOptions: prefixFilterOptions,
                                })}
                                label={translate(el.label || "")}
                                placeholder={translate(el.placeholder || "")}
                                className={`h-20 box-border ${
                                  !isSmallScreen ? "px-8" : ""
                                }`}
                                onchange={(e: any) => {
                                  const r = Object.keys(
                                    CompanyInvoiceFormFields
                                  ).at(index);

                                  if (
                                    el.key === "birthNation" &&
                                    e === "ITALIA"
                                  ) {
                                    setTaxVal("");
                                    setIsReadonly(false);
                                  } else if (
                                    el.key === "birthNation" &&
                                    e !== "ITALIA"
                                  ) {
                                    setTaxVal("9999999999999999");
                                    setIsReadonly(true);
                                  }

                                  setCompanyinvoiceDetails({
                                    ...companyinvoiceDetails,
                                    [r]: e,
                                  });

                                  if (el.key === "country") {
                                    handleCountryChange(e);
                                  }

                                  setValue(el.key, e || "");
                                }}
                              />
                              <FormFieldErrorMessage>
                                {errors[el.key]?.message}
                              </FormFieldErrorMessage>
                            </>
                          )}
                        </div>
                      )}
                    </>
                  );
                })}
              </div>
            ) : null}
          </div>
        </>
      )}
    </div>
  );
}

export default NewCompanyDetails;
